// node_modules
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

// styles
import * as styles from "./StatusScreen.module.css";

const StatusScreen = () => {
  const statusWS = useRef(null);

  const { stationId } = useParams();

  const [ordersInProgress, setOrdersInProgress] = useState();
  const [ordersDone, setOrdersDone] = useState();
  const [isExist, setIsExist] = useState(true);
  const [isClosed, setIsClosed] = useState(false);
  const [stationName, setStationName] = useState(null);

  useEffect(() => {
    statusWS.current = new WebSocket(`wss://dwtl.food/ws`);

    statusWS.current.addEventListener("open", () => {
      statusWS.current.send(JSON.stringify({ type: "stations-orders" }));

      // clearInterval(pingIntervalId.current);
      // pingIntervalId.current = setInterval(() => {
      //   try {
      //     statusWS.send(JSON.stringify({ type: "ping" }));
      //   } catch (e) {
      //     console.warn("⚠️ Ping failed:", e);
      //   }
      // }, 55 * 1000);
      // reconnectDelay.current = 1000;
    });

    statusWS.current.addEventListener("message", (event) => {
      const data = JSON.parse(event.data);

      if (data.type === "stations-orders") {
        const station = data.data.find((item) => item.id === +stationId);

        if (!station) {
          setIsExist(false);
        } else {
          setStationName(station.name);
          setIsClosed(!!station.isClosed);
          console.log(station);
          const readyOrders = station.orders.filter(
            (order) => order.status === 1
          );
          const inProgressOrders = station.orders.filter(
            (order) => order.status === 0
          );
          setOrdersDone(readyOrders);
          setOrdersInProgress(inProgressOrders);
        }
      }
    });

    return () => {
      statusWS.current.close();
    };
  }, []);

  return (
    <div className={styles.pageWrapper}>
      {isExist ? (
        <>
          <h1>
            {stationName} {isClosed && "CLOSED"}
          </h1>
          <div className={styles.columnsWrapper}>
            <div className={styles.columnInProgress}>
              <div className={styles.columnHeader}>IN PROCESS</div>
              <div className={styles.orders}>
                {!!ordersInProgress?.length &&
                  ordersInProgress.map((order) => {
                    return (
                      <div className={styles.orderNumber}>{order.number}</div>
                    );
                  })}
              </div>
            </div>
            <div className={styles.columnReady}>
              <div className={styles.columnHeader}>READY TO PICK UP</div>
              <div className={styles.orders}>
                {!!ordersDone?.length &&
                  ordersDone.map((order) => {
                    return (
                      <div className={styles.orderNumber}>{order.number}</div>
                    );
                  })}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>STATION NOT EXIST</div>
      )}
    </div>
  );
};

export default StatusScreen;
